module.exports = __webpack_public_path__ + "img/Thai Fa Power mobile.bee9d64b.png";